<app-login-layout header="Welcome to brightscrip™">
  @if (error()) {
    <div class="alert alert-danger col-10 mt-4" role="alert" data-cy="alert" data-testid="login-error">
      <div class="alert-message"><strong class="pe-1">There's been an issue: </strong>{{ error() }}</div>
    </div>
  }
  @if (success()) {
    <div class="alert alert-success col-10 mt-4" role="alert" data-cy="alert">
      <div class="alert-message"><b class="pe-1">Success! </b> {{ success() }}</div>
    </div>
  }
  @switch (view()) {
    @case ('confirm') {
      <app-pass-form (send)="onPassConfirm($event)" [isSending]="isSending()" />
      @if (contactFormEnabled()) {
        <a class="mt-4 d-block w-fit forgot-password-link" (click)="showContactForm()" data-cy="contactUs">Contact us via SMS or email</a>
      }
      <a (click)="reset()" class="mt-2 d-block w-fit forgot-password-link" data-cy="backToLogin">Back to login</a>
    }
    @case ('setupPhone') {
      <form (ngSubmit)="onSetupPhone()">
        <p>To protect your account, please set up two-factor authentication.</p>
        <div class="mt-4 mb-3 login-field">
          <label class="form-label" for="phone">Phone number</label>
          <input
            [(ngModel)]="challengeResponse"
            (keypress)="onSetupPhoneChange($event)"
            required
            type="tel"
            id="phone"
            name="phone"
            class="form-control"
            autocomplete="phone"
            maxlength="15"
            [disabled]="isSending()"
          />
        </div>
        <chitin-button type="submit" data-cy="continueBtn" label="Continue" [isLoading]="isSending()" />
      </form>
      <a (click)="reset()" class="mt-4 d-block w-fit forgot-password-link" data-cy="backToLogin">Back to login</a>
    }
    @case ('mfa') {
      <form (ngSubmit)="onMfa()">
        <p>
          @if (mfaType() === 'email') {
            We've sent an email to your email address.
          } @else {
            We've sent a text message to your phone number.
          }
        </p>
        <div class="mt-4 mb-3 login-field">
          <app-digit-code label="Enter the 6-digit code" [(code)]="challengeResponse" [disabled]="isSending()" (completed)="onMfa()" />
        </div>
        <chitin-button type="submit" data-cy="continueBtn" data-testid="continueBtn" label="Continue" [isLoading]="isSending()" />
      </form>

      <p class="mt-4 mb-0">
        Didn't receive a code?
        @if (resend() === 0) {
          <a (click)="onResendCode()" class="forgot-password-link" data-cy="resendMfa">Resend code</a>
        } @else {
          <span> Resend code ({{ resend() | interval }})</span>
        }
        @if (contactFormEnabled()) {
          <a class="mt-2 d-block w-fit forgot-password-link" (click)="showContactForm()" data-cy="contactUs">Contact us via SMS or email</a>
        }
      </p>

      <a (click)="reset()" class="mt-4 d-block w-fit forgot-password-link" data-cy="backToLogin">Back to login</a>
    }
    @case ('login') {
      <form (ngSubmit)="onLogin()">
        <div class="mt-4 mb-3 login-field">
          <label class="form-label" for="username">Username</label>
          <input
            type="text"
            [(ngModel)]="username"
            name="username"
            id="username"
            required
            class="form-control"
            data-testid="login-username"
            [disabled]="isSending()"
          />
        </div>
        <div class="mb-3 login-field">
          <label class="form-label" for="password">Password</label>
          <input
            type="password"
            [(ngModel)]="password"
            name="password"
            id="password"
            required
            class="form-control"
            data-testid="login-password"
            [disabled]="isSending()"
          />
        </div>
        <chitin-checkbox [(value)]="agreedToConditions" class="d-block mb-3" data-testid="login-agree">
          I agree to <a href="terms-of-use" target="_blank" data-testid="login-terms-link">Terms of Use</a> and
          <a href="privacy-policy" target="_blank" data-testid="login-privacy-link">Privacy Policy</a>
        </chitin-checkbox>
        <chitin-button
          type="submit"
          data-cy="loginBtn"
          data-testid="login-signin"
          label="Sign in"
          [isLoading]="isSending()"
          [disabled]="!agreedToConditions()"
        />
      </form>

      <a routerLink="/login/forgot" class="mt-4 d-block w-fit forgot-password-link" data-cy="forgotPassword">Forgot password?</a>

      @if (contactFormEnabled()) {
        <a class="mt-2 d-block w-fit forgot-password-link" (click)="showContactForm()" data-cy="contactUs">Contact us via SMS or email</a>
      }
    }
    @default {
      <p class="text-danger">Unknown view: {{ view() }}</p>
    }
  }
</app-login-layout>
